export default function IntroSection() {
  return (
    <section className="bg-[#111111] py-24">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-8 h-px bg-[#d4af37]"></div>
          <span className="text-[#d4af37] text-xs uppercase tracking-[3px] font-semibold">Who We Are</span>
          <div className="w-8 h-px bg-[#d4af37]"></div>
        </div>
        <p className="text-2xl md:text-3xl text-[#d0d0d0] leading-relaxed font-light">
          Advantixx Home Health Accreditation Consultants provides expert, results-driven consulting services to home health agencies seeking{' '}
          <strong className="text-[#d4af37] font-semibold">ACHC accreditation</strong> and compliance. We simplify the process, eliminate delays, and position your agency for{' '}
          <strong className="text-[#d4af37] font-semibold">long-term success</strong>.
        </p>
      </div>
    </section>
  );
}
